<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative text-center">
      <div>¿Estás seguro que deseas eliminar este elemento?</div>

      <primary-button
        class="mt-4 bg-error-500 hover:bg-error-600"
        :loading="loading"
        @buttonClicked="confirmDelete"
        >Eliminar
      </primary-button>

      <button class="mt-4 mx-auto w-full system-button" @click.prevent="close">
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: false,
  },

  methods: {
    close() {
      this.$emit("close");
    },

    confirmDelete() {
      this.$emit("confirmDelete");
    },
  },
};
</script>